/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_cloud_logic_custom": [
        {
            "name": "analytics",
            "endpoint": "https://y5fk9367ul.execute-api.eu-north-1.amazonaws.com/prod",
            "region": "eu-north-1"
        },
        {
            "name": "coreAgent",
            "endpoint": "https://z79elgvfz5.execute-api.eu-north-1.amazonaws.com/prod",
            "region": "eu-north-1"
        },
        {
            "name": "coretransact",
            "endpoint": "https://qnrfokq6hk.execute-api.eu-north-1.amazonaws.com/prod",
            "region": "eu-north-1"
        },
        {
            "name": "coreuser",
            "endpoint": "https://ms5h24ll1b.execute-api.eu-north-1.amazonaws.com/prod",
            "region": "eu-north-1"
        },
        {
            "name": "querytransact",
            "endpoint": "https://gcyhtpt282.execute-api.eu-north-1.amazonaws.com/prod",
            "region": "eu-north-1"
        },
        {
            "name": "coreAdmin",
            "endpoint": "https://wzln1nqyeg.execute-api.eu-north-1.amazonaws.com/prod",
            "region": "eu-north-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://g73s3ggtvvcftjh4kbf6dhv2xa.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-north-1:64f60fe3-ee1c-4f1b-834d-dd1d6fca4f55",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_NiqJi5D3g",
    "aws_user_pools_web_client_id": "1ur1pdbtp4qmnuji4bqhesotk2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_dynamodb_all_tables_region": "eu-north-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "GameAnalytics-prod",
            "region": "eu-north-1"
        },
        {
            "tableName": "TransactionLog-prod",
            "region": "eu-north-1"
        },
        {
            "tableName": "UserAttributes-prod",
            "region": "eu-north-1"
        },
        {
            "tableName": "UserTree-prod",
            "region": "eu-north-1"
        },
        {
            "tableName": "Limits-prod",
            "region": "eu-north-1"
        }
    ],
    "aws_user_files_s3_bucket": "admindata520bf-prod",
    "aws_user_files_s3_bucket_region": "eu-north-1"
};


export default awsmobile;
